'use client'
import { ArrowLeftIcon, MessageIcon } from '@/components/icons/svg-icons';
import { PageTabBar } from '@/components/widgets/page-tab-bar';
import { MessageItem } from './message-item';
import { EmptyMessageItem } from './empty-message-item';
import { useState, useEffect } from 'react';
import { useMessages, Message } from '@/hooks/query/use-account-messages';
import { useLocale, useTranslations } from 'next-intl';
import { useFilterSabaString } from '@/hooks/query/use-saba-filter';
import { useAppearanceStore } from '@/store/appearance';
import { ViewEnum } from '@/types';
import clsx from 'clsx';
import { routerService } from '@/services/router.service';
import { usePathname, useRouter } from '@/navigation';
import { siteService } from '@/services/site.service';
import { LicenseeTypeEnums } from '@nf/types/site';
import { Button } from '@nf/ui';
import { pageHeader } from 'styled-system/recipes';
import { useBreakpoint } from '../breakpoint/contexts';
import { Breakpoint } from '../breakpoint';

export function AccountMessage() {
	const [messages, setMessages] = useState<Message[]>([]);
	const [buttonIndex, setButtonIndex] = useState(0);
	const t = useTranslations('General');
	const { filterSabaString } = useFilterSabaString();
	const { refetch } = useMessages(buttonIndex.toString());
	const view = useAppearanceStore(state => state.view);
	const isAthena = siteService.getLicenseeType() === LicenseeTypeEnums.Athena;
	const router = useRouter();
	const locale = useLocale()
	const pathName = usePathname();
	const { breakpoint } = useBreakpoint();
	const isMobile = breakpoint <= Breakpoint.sm;
	const tabLists = [{
		slug: 'General',
		name: `${t('lbl_General')}`,
	}, {
		slug: 'Special',
		name: `${t('lbl_Special')}`,
	}, {
		slug: 'Personal',
		name: `${t('lbl_Personal')}`,
	}]

	function handleMessages(data: Message[]) {
		setMessages(data.slice(0, 50));
	}

	const goToPreviousPage = () => {
		routerService.pop(router.push, locale, pathName, view);
	}

	const handleClick = (index: number) => {
		setButtonIndex(index)
	}
	useEffect(() => {
		refetch().then((queryResult) => {
			if (queryResult.data) {
				handleMessages(queryResult?.data.data.Data);
			}
		});
	}, [buttonIndex]);

	return (
		<>
			<section className={clsx('page-header', pageHeader({ behavior: 'withBack' }))}>
				<div className="page-header__group">
					<div className="page-header__title">
						{isAthena && isMobile ? (
							// athena 版本需要新增返回按鈕, api site不需要因為使用simple header
							<Button variant="icon" className="btn--arrow-left" onClick={goToPreviousPage}>
								<ArrowLeftIcon />
							</Button>
						) : (
							<MessageIcon />
						)}
						<h3 className="page-header__title-text">{t('Msg')}</h3>
					</div>
				</div>
				<div className="page-header__group"></div>
			</section>

			<PageTabBar tabList={tabLists} onTabLink={handleClick} tabDefaultIndex={0} isMyBetHasBooked={false} />

			<section className={clsx('message', { 'scrollbar': view === ViewEnum.mars })}>
				{messages.length > 0 ? (
					messages.map((message, i) => {
						return <MessageItem key={`${message.posttime}_${i}`} posttime={message.posttime} content={filterSabaString(message.content)} />
					})
				) : (
					<EmptyMessageItem />
				)}
			</section>
		</>
	);

}